import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BasicResponse} from '../core/interfaces/basic-response';

const API_URL = environment.apiUrl;
const API_VERSION = environment.MSReadingBrainSafetyVersion;
const SERVICE = 'msreadingbrainsafety-dot-';
const SERVICE_API_URL = `https://${API_VERSION}${SERVICE}${API_URL}`;

@Injectable({
    providedIn: 'root'
})
export class ReadingBrainSafetyService {

    constructor(private http: HttpClient) {
    }

    getNumberOfAvailableReadings(studyId, readerId): Observable<BasicResponse<number>> {
        return this.http.get<BasicResponse<any>>(`${SERVICE_API_URL}/readings/available-count/studyId-${studyId}/readerId-${readerId}`);
    }

    getAvailableReadings(studyId, readerId): Observable<BasicResponse<any>> {
        return this.http.get<BasicResponse<any>>(`${SERVICE_API_URL}/readings/available/studyId-${studyId}/readerId-${readerId}`);
    }

    updateReading(readingId, spentSeconds): Observable<BasicResponse<any>> {
        return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/log-time`, spentSeconds);
    }

    startReading(readingId): Observable<BasicResponse<any>> {
        return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/start`, null);
    }

    saveReadingForm(readingId, visitId, model) {
        const customHeader = new HttpHeaders({
            'Authorization': `Bearer ` + JSON.parse(localStorage.getItem('currentUser'))
        });
        return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/update`, model, { headers: customHeader });
    }

    completeReading(readingId, reading: any, jwtToken): Observable<BasicResponse<any>> {
        const customHeader = new HttpHeaders({
            'Authorization': `Bearer ${jwtToken}`
        });
        return this.http.put<BasicResponse<any>>(`${SERVICE_API_URL}/readings/${readingId}/complete`, reading, {
            headers: customHeader
        });
    }
}
